import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import TractInfo from "./TractInfo";
import { PulseLoader } from "react-spinners";
import ReportFormsHolder from "./ReportFormsHolder";

export default function ReportForm() {
  const { id } = useParams();

  const { data, refresh } = useFetch(`/reports/${id}`);

  const tractInfo = useMemo(() => {
    if (!data) return null;
    return { ...data.tract_details, status: data.status, report_year: data.report_year }
  }, [data]);

  return (
    <div className="w-full flex flex-col items-stretch">
      <div className="border-b-2 border-b-zinc-200 pb-4">
        <h2 className="font-bold text-2xl dark:text-white">Reports</h2>
        <p className="text-gray-1 mt-2">
          Track, manage, and create tract reports
        </p>
      </div>

      {!data && <PulseLoader className="p-16 self-center justify-center" color="#658245" />}

      {data && <TractInfo data={tractInfo} />}
      <ReportFormsHolder
        reportId={id}
        data={data}
        refreshData={refresh}
        requireTractConfirm
        showWater
        showCrops
        showSoil
      />
    </div>
  );
}
